import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { AreaLabelComponent } from './area-label.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        AreaLabelComponent
    ],
    exports: [
        AreaLabelComponent
    ]
})
export class AreaLabelModule { }
